module.exports = __webpack_public_path__ + "img/更轻松.5e613b97.png";